export const ADDRESS_FIELD_LABELS = {
    street: "Strasse",
    zip: "PLZ",
    city: "Ort",
    country: "Land",
};

export const ADDRESS_REQUIRED_MESSAGES = {
    street: "Bitte Strasse eingeben.",
    zip: "Bitte PLZ eingeben.",
    city: "Bitte Ort eingeben.",
    country: "Bitte Land auswählen.",
};

export const DEFAULT_COUNTRY_CODE = "DE";
export const PRIORITY_COUNTRY_CODES = ["DE", "AT", "CH"];

export const COUNTRIES = [
    { code: "DE", name: "Deutschland" },
    { code: "AT", name: "Österreich" },
    { code: "CH", name: "Schweiz" },
    { code: "BE", name: "Belgien" },
    { code: "BG", name: "Bulgarien" },
    { code: "CY", name: "Zypern" },
    { code: "CZ", name: "Tschechische Republik" },
    { code: "DK", name: "Dänemark" },
    { code: "EE", name: "Estland" },
    { code: "ES", name: "Spanien" },
    { code: "FI", name: "Finnland" },
    { code: "FR", name: "Frankreich" },
    { code: "GR", name: "Griechenland" },
    { code: "HR", name: "Kroatien" },
    { code: "HU", name: "Ungarn" },
    { code: "IE", name: "Irland" },
    { code: "IT", name: "Italien" },
    { code: "LT", name: "Litauen" },
    { code: "LU", name: "Luxemburg" },
    { code: "LV", name: "Lettland" },
    { code: "MT", name: "Malta" },
    { code: "NL", name: "Niederlande" },
    { code: "PL", name: "Polen" },
    { code: "PT", name: "Portugal" },
    { code: "RO", name: "Rumänien" },
    { code: "SE", name: "Schweden" },
    { code: "SI", name: "Slowenien" },
    { code: "SK", name: "Slowakei" },
    { code: "US", name: "USA" },
];

export const getCountryName = (code) => {
    if (!code) return "—";
    const match = COUNTRIES.find((entry) => entry.code === code);
    return match ? match.name : code;
};
